var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-title',{attrs:{"color":false,"title":'Home Challenge'}}),_c('div',{staticClass:"py-3 container px-lg-5 full-size-img",domProps:{"innerHTML":_vm._s(_vm.getCriterionDescription)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }